import Icon from '../components/Icon.vue'

Icon.register({
  'globe-africa': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM408 223.5c0-8.6 6.9-15.5 15.5-15.5h18.4c-19.1-77-82.7-136.4-161.9-149.2v21.7c0 8.6-6.9 15.5-15.5 15.5h-24.2c-5.2 0-10 2.6-12.9 6.9l-8.1 12.1c-2.1 3.2-5.4 5.5-9.1 6.4l-14.5 3.6c-6.9 1.7-11.7 7.9-11.7 15v4.4c0 8.6 6.9 15.5 15.5 15.5h90 0c3.5 0 8.5 2 11 4.5l6.9 6.9c2.9 2.9 6.9 4.5 11 4.5h10.1c8.6 0 15.5 6.9 15.5 15.5 0 6.7-4.3 12.6-10.6 14.7l-47.3 15.8c-3.9 1.3-8.2 1-11.8-0.8l-14.7-7.4c-7.6-3.8-15.9-5.8-24.4-5.8h-0.9c-10.1 0-24.7 4.9-32.8 10.9l-27.6 20.7c-13.8 10.3-21.8 26.5-21.8 43.7v14.1c0 12.5 7.2 29.8 16 38.6 10.3 10.2 24.1 16 38.6 16h25.9c8.6 0 15.5 6.9 15.5 15.5v29.9 0c0 10.3 3.7 26.1 8.3 35.3 4.7 9.4 14.3 15.3 24.8 15.3 8.2 0 18.5-5.5 23.1-12.4l13-19.5c5.9-8.9 17.1-21.9 25-29.2 2.5-2.3 4.1-5.3 4.8-8.6l4.3-22.8c0.4-2.3 1.4-4.5 2.8-6.4l18.7-25c2-2.7 3.1-6 3.1-9.3v-11.3c0-8.6-6.9-15.5-15.5-15.5h-8.2c-5.2 0-10-2.6-12.9-6.9l-13.2-19.9c-5.7-8.5-1.7-20.1 8-23.3l2.6-0.9c1.3-0.4 3.5-0.8 4.9-0.8 2.6 0 6.4 1.2 8.6 2.6l18.2 12.1c2.2 1.4 6 2.6 8.6 2.6 2 0 5.1-0.7 6.9-1.6l15.4-7.7c5.3-2.6 8.6-8 8.6-13.9v-6.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-africa.js
// module id = 1388
// module chunks = 0